import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NewSimulationService} from '../new-simulation.service';
import {SimulationsService} from "../../simulation-list/simulations.service";

@Component({
  selector: 'app-simulation-result',
  templateUrl: './simulation-result.component.html',
  styleUrls: ['./simulation-result.component.css']
})
export class SimulationResultComponent implements OnInit {

  public sectionData: any;
  public periodData: any;
  public colspan : number;
  public currency : any;

  public firstChartData = {};
  public secondChartData = {};
  public thirdChartData = {};
  public fourthChartData = {};

  constructor(private service: NewSimulationService, private simulationService: SimulationsService) {
    this.sectionData = service.sections[3].data;
    this.periodData = service.sections[2].data;
    this.currency = service.sections[1].data[0].currency;
    this.colspan = this.periodData.length;

    this.generateChartDatas(this.sectionData);
  }

  ngOnInit() {
  }

  private generateChartDatas(result) {
      const firstChartData = [];
      firstChartData.push({
              title: 'Total Gross Revenue',
              value: Number.parseFloat(result['TOTGR']),
              color: '150, 162, 166',
              postfix: this.currency
          },
          {
              title: 'Total Net Revenue',
              value: Number.parseFloat(result['TOTNR']),
              color: '150, 162, 166,',
              postfix: this.currency
          }
      );

      const secondCharData = [];
      for (let i = 0; i < result['GRCYC'].length; i++) {

          const grcyc = Number.parseFloat(result['GRCYC'][i]);
          const nrcyc = Number.parseFloat(result['NRCYC'][i]);

          secondCharData.push({
              name: 'Period ' + (i + 1),
              total: grcyc + nrcyc,
              postfix: this.currency,
              series: [
                  {
                      name: 'Gross Revenue per MEA period',
                      value: grcyc
                  },
                  {
                      name: 'Net Revenue per MEA period',
                      value: nrcyc
                  }
              ]
          });
      }

      const thirdChardData = [];
      for (let i = 0; i < result['EXFNETPCYC'].length; i++) {

          const exfnetpcyc = Number.parseFloat(result['EXFNETPCYC'][i]);
          const exflistp = Number.parseFloat(this.periodData[i]['EXFLISTP']);

          thirdChardData.push({
              name: 'Period ' + (i + 1),
              total: exfnetpcyc + exflistp,
              postfix: this.currency,
              series: [
                  {
                      name: 'List Price per MEA period',
                      value: exflistp
                  },
                  {
                      name: 'Net ExF Price per MEA period',
                      value: exfnetpcyc
                  }
              ]

          })


      }

      const fourthChartData = {
          name: "Total discount",
          value: Number.parseFloat(result['DSC'])
      };

      this.firstChartData = firstChartData;
      this.secondChartData = secondCharData;
      this.thirdChartData = thirdChardData;
      this.fourthChartData = fourthChartData;
  }
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/simulation-result/simulation-result.component.ts